module.exports = __webpack_public_path__ + "static/foodprep-597598750d4ac470aa33a3272164f25b.jpeg";